const selectors = {
  error: '[data-newsletter-error]',
  newsletter: '[data-newsletter]',
};

class Newsletter {
  constructor() {
    this.newsletter = document.querySelector(selectors.newsletter);

    if (!this.newsletter) {
      return;
    }

    this.init();
  }

  init() {
    this.customerPosted = false;
    const searchParams = new URLSearchParams(window.location.search);

    // Check if the URL has an 'customer_posted' parameter...
    if (searchParams.has('customer_posted')) {
      // If so, select the correct customer_posted value...
      this.customerPosted = Boolean(searchParams.get('customer_posted'));
    }

    this.acceptsMarketing = false;
    // Check if the URL has a 'contact[accepts_marketing]' parameter...
    if (searchParams.has('contact[accepts_marketing]')) {
      // If so, check if the value is on.
      this.acceptsMarketing =
        searchParams.get('contact[accepts_marketing]') === 'on';
    }

    this.errors = [...this.newsletter.querySelectorAll(selectors.error)];

    if (
      this.customerPosted ||
      this.acceptsMarketing ||
      this.errors.length > 0
    ) {
      setTimeout(() => {
        this.scrollToNewsletter();
      }, 200);
    }
  }

  scrollToNewsletter() {
    this.newsletter.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }
}

const newsletter = () => new Newsletter();
export default newsletter;
